:host {
  display: inline-block;
  width: 100%;
}

input {
  font-family: var(--primary-font), sans-serif;
}

.range_container {
  display: flex;
  flex-direction: column;
  margin-top: 13px;

  .sliders_control {
    position: relative;
    min-height: 30px;
    width: calc(100% - 15px);
    margin-left: auto;
    margin-right: auto;

    .range-slider-labels {
      position: relative;
      display: flex;
      justify-content: space-between;
      font-size: 24px;
    }

    input[type='range'] {
      -webkit-appearance: none;
      appearance: none;
      height: 3px;
      width: 100%;
      position: absolute;
      background-color: var(--color-gray-medium);
      pointer-events: none;
    }

    input[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
      pointer-events: all;
      width: 18px;
      height: 18px;
      background-color: var(--color-livique-anthrazit);
      border-radius: 50%;
      box-shadow: 0 0 0 1px var(--color-gray-medium);
      cursor: pointer;
    }

    input[type='range']::-moz-range-thumb {
      -webkit-appearance: none;
      pointer-events: all;
      width: 18px;
      height: 18px;
      background-color: var(--color-livique-anthrazit);
      border-radius: 50%;
      box-shadow: 0 0 0 1px var(--color-gray-medium);
      cursor: pointer;
    }

    input[type='range']::-webkit-slider-thumb:hover {
      background: var(--color-nero);
    }

    input[type='range']::-webkit-slider-thumb:active {
      box-shadow: inset 0 0 3px var(--color-livique-anthrazit), 0 0 9px var(--color-livique-anthrazit);
      -webkit-box-shadow: inset 0 0 3px var(--color-livique-anthrazit), 0 0 9px var(--color-livique-anthrazit);
    }

    #fromSlider {
      height: 0;
      z-index: 1;
    }
  }

  .range-slider-labels {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    line-height: 27px;
    font-family: var(--primary-font);
    color: var(--color-nero);
    padding: 0 5px;

    .range-slider-label-container {
      border: 1px solid var(--color-silver);
      padding: 5px;
      border-radius: 3px;
      display: flex;
      position: relative;
      top: 0;
      left: 0;

      &.invalid {
        border: 1px solid var(--color-error);
        box-shadow: 0 0 0.4rem var(--color-error);
        animation: shake 0.15s ease-in-out 0s 3;
        z-index: 100;
      }

      @keyframes shake {
        0% {
          left: 0px;
        }
        25% {
          left: 5px;
        }
        75% {
          left: -5px;
        }
        100% {
          left: 0px;
        }
      }

      .range-slider-label {
        font-size: 16px;
        line-height: 27px;
        font-family: var(--primary-font);
        color: var(--color-nero);
      }

      .range-slider-value-input {
        border: none;
        margin-left: 5px;
        font-size: 16px;
        line-height: 27px;
        font-family: var(--primary-font);
        color: var(--color-nero);
        padding: 0;
        width: 45px;
        text-align: right;
        // Hides native spinner controls mostly cross-browser
        -moz-appearance: textfield;
        -ms-appearance: textfield;
        -webkit-appearance: textfield;
        appearance: textfield;

        // Hides native spinner controls in Webkit
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }
}
